export * from './new.component';
export * from './new.service';
